import React, { useRef } from "react";

const ActionTypeTab = ({ activeTarget, handleChange }) => {
  const navLinksRef = useRef({});

  const handleClick = (event) => {
    event.preventDefault();
    const target = event.currentTarget.getAttribute("data-target");
    handleChange(target);

    // Update the class names for active and inactive links
    Object.values(navLinksRef.current).forEach((link) => {
      link.classList.remove("active");
    });

    if (navLinksRef.current[target]) {
      navLinksRef.current[target].classList.add("active");
    }
  };

  return (
    <div className="col-md-3">
      <div className="mb-3 w-100 d-flex justify-content-center align-items-center">
        <div style={{ border: "none" }} className="dmqGroup">
          <button
            className={`${
              activeTarget === "Recommended Actions" ? "active" : ""
            }`}
            data-target="Recommended Actions"
            ref={(el) => (navLinksRef.current["Recommended Actions"] = el)}
            onClick={handleClick}
          >
            Actions Dashboard
          </button>
          &nbsp; &nbsp;
          <button
            className={`${activeTarget === "Actions List" ? "active" : ""}`}
            data-target="Actions List"
            ref={(el) => (navLinksRef.current["Actions List"] = el)}
            onClick={handleClick}
          >
            Actions List
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActionTypeTab;
